import React, { useState } from "react";
import styled from "@emotion/styled";
import { useTheme } from "@emotion/react";
import Image from "@components/item/Image";
import BasicButton from "@components/button/BasicButton";
import useOptionDrawerStore from "@store/productDetail/useOptionDrawerStore";
import { useNavigate, useParams } from "react-router-dom";
import useProductIdStore from "@store/productDetail/useProductIdStore";
import { useQuery } from "@tanstack/react-query";
import { useApiRequest } from "@utils/ApiRequest";
import useUserInfoStore from "@store/useUserInfoStore";

const FooterContainer = styled.footer(({ theme }) => ({
  position: "fixed",
  bottom: 0,
  display: "flex",
  alignItem: "center",
  justifyContent: "space-between",
  padding: "1.4rem 1rem",
  gap: "1.5rem",
  width: "100%",
  maxWidth: "560px",
  height: "80px",
  backgroundColor: theme.color.white,
  textAlign: "center",
  zIndex: 2,
  borderTop: `1px solid ${theme.color.border_gray}`,
}));

const IconButtonWrapper = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  gap: "",
  fontSize: "1.2rem",
  fontWeight: theme.fontWeight.medium,
  cursor: "pointer",
}));

const PurchaseFooter = () => {
  const theme = useTheme();
  const { setOpen } = useOptionDrawerStore();
  const { productId } = useProductIdStore();
  const { getProductDetail } = useApiRequest();
  const navigate = useNavigate();
  const { userInfo } = useUserInfoStore();

  const { data: productInfo } = useQuery({
    queryKey: ["productInfo", productId],
    queryFn: () => getProductDetail(Number(productId)),
    enabled: !!productId,
  });

  const handleNavigateQna = () => {
    navigate(`/product-qna/${productId}`);
  };

  return (
    <>
      <FooterContainer>
        <IconButtonWrapper onClick={handleNavigateQna}>
          <Image
            src={theme.image.chat_black.default}
            width="3.2rem"
            height="3.2rem"
          />
          <span>{productInfo?.qna_count ? productInfo?.qna_count : 0}</span>
        </IconButtonWrapper>
        {productInfo?.seller_id !== userInfo?.id && (
          <BasicButton
            title="구매하기"
            width="100%"
            height="100%"
            onClick={() => setOpen(true)}
          />
        )}
      </FooterContainer>
    </>
  );
};

export default PurchaseFooter;
